var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProjDataB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2641_6765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 29C22.5081 29 29 22.5081 29 14.5C29 6.49187 22.5081 0 14.5 0C6.49187 0 0 6.49187 0 14.5C0 22.5081 6.49187 29 14.5 29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79688 12.1616C7.79688 10.9854 7.79687 10.3979 8.16234 10.0325C8.5278 9.66699 9.11528 9.66699 10.2915 9.66699H17.7754C18.9516 9.66699 19.5391 9.66699 19.9045 10.0325C20.27 10.3979 20.27 10.9854 20.27 12.1616C20.27 12.4554 20.27 12.6025 20.1789 12.6942C20.0873 12.7853 19.9395 12.7853 19.6463 12.7853H8.42053C8.12679 12.7853 7.97961 12.7853 7.88793 12.6942C7.79687 12.6025 7.79688 12.4547 7.79688 12.1616ZM7.79688 17.7745C7.79688 18.9507 7.79687 19.5382 8.16234 19.9037C8.5278 20.2691 9.11528 20.2691 10.2915 20.2691H17.7754C18.9516 20.2691 19.5391 20.2691 19.9045 19.9037C20.27 19.5382 20.27 18.9507 20.27 17.7745V14.6562C20.27 14.3625 20.27 14.2153 20.1789 14.1236C20.0873 14.0326 19.9395 14.0326 19.6463 14.0326H8.42053C8.12679 14.0326 7.97961 14.0326 7.88793 14.1236C7.79687 14.2153 7.79688 14.3631 7.79688 14.6562V17.7745Z",
    fill: "#6796CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.916 8.41992V10.2909M17.1526 8.41992V10.2909",
    stroke: "#6796CF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2641_6765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjDataB);
export default __webpack_public_path__ + "static/media/IconProjDataB.a8683e7370b67b28ebb68c599ead0fd5.svg";
export { ForwardRef as ReactComponent };